<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import type { CurrentRoute } from "svelte-router-spa/types/components/route";

  import router from "@/router";
  import Spacer from "@/components/spacer.svelte";
  import SubnavUnit from "@/components/subnav-unit.svelte";
  import Subnav_4depth from "./subnav-4depth.svelte";

  const menulist = router.find((x) => x.id == "service")?.nestedRoutes || [];

  const map = {
    product: [
      {
        name: "스마트팜",
        img: "/images/system/smartfarm/smartfarm",
      },
      {
        name: "자동관수",
        img: "/images/system/smartfarm/water",
      },
      {
        name: "양액시스템",
        img: "/images/system/smartfarm/nutrient",
      },
      // {
      //   name: "레일제어시스템",
      //   img: "/images/system/smartfarm/railSystem",
      // },
    ],
    consult: [
      {
        name: "VR시뮬레이터",
        img: "/images/system/consult/vr",
      },
      {
        name: "3D시뮬레이터",
        img: "/images/system/consult/3d",
      },
      {
        name: "스마트팜 전시모형",
        img: "/images/system/consult/model",
      },
      // {
      //   name: "VR",
      //   img: "/images/system/consult/vr",
      // },
      // {
      //   name: "교육/강의",
      //   img: "/images/system/consult/education",
      // },
    ],
    management: [
      {
        name: "팜노트",
        img: "/images/system/management/farmnote",
      },

      {
        name: "사후관리 시스템",
        img: "/images/system/management/as",
      },
    ],
    development: [
      {
        name: "AI 자동예측 프로그램",
        img: "/images/system/development/ai",
      },
      {
        name: "식물공장",
        img: "/images/system/development/plantfactory",
      },
      {
        name: "탄소배출",
        img: "/images/system/development/co2",
      },
    ],
  };

  export let currentRoute: CurrentRoute;
  export let currentFourthMenuIndex = 0;

  /** 경로의 맨 뒷자리 (computed) */
  let pathname;
  $: {
    pathname = currentRoute.path.split("/").pop();
  }
</script>

<Spacer size="150px" />

<div id="wrap">
  <h1>SERVICE</h1>

  <Spacer size="2rem" />

  <!-- 텍스트 탭 2차메뉴 -->
  <div class="position-relative">
    <div class="position-absolute w600-mobile start-50 translate-middle-x">
      <Row style="--bs-gutter-x: 0 !important;">
        {#each menulist as menu, i}
          <Col style="padding: 0 !important;">
            <SubnavUnit
              href="/service/{menu.name}"
              active={pathname == menu.name}
            >
              {menu.label}
            </SubnavUnit>
          </Col>
        {/each}
      </Row>
    </div>
  </div>

  <Spacer size="5rem" class_ext="pc" />
  <Spacer size="6rem" class_ext="mobile" />

  <!-- 이미지와 함께 있는 3차메뉴 -->
  <div class="text-center position-relative">
    <div class="w100per position-absolute start-50 translate-middle-x">
      {#each map[pathname] as nav, i}
        <Subnav_4depth
          imagepath={nav.img}
          name={nav.name}
          thisIndex={i}
          bind:currentIndex={currentFourthMenuIndex}
        />
      {/each}
    </div>
  </div>
</div>

<style lang="scss">
  .w600-mobile {
    width: 330px;
  }
  @media (min-width: 768px) {
    .w600-mobile {
      width: 600px !important;
    }
  }
  .w100per {
    width: 100%;
  }

  #wrap {
    color: #5c3327;

    h1 {
      font-size: 3rem;
      font-weight: 700;
      text-align: center;
    }
  }
</style>
